import { render, staticRenderFns } from "./widgetSecRiskTrend.vue?vue&type=template&id=73b9852e&scoped=true&"
import script from "./widgetSecRiskTrend.vue?vue&type=script&lang=js&"
export * from "./widgetSecRiskTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b9852e",
  null
  
)

export default component.exports